import { Phone, MessageSquare, FileText } from "lucide-react";
import { CONTACT } from "@/data/content";

export const StickyCallBar = () => {
  return (
    <div data-testid="sticky-call-bar" className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 grid grid-cols-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <a href={CONTACT.phoneHref} data-testid="sticky-call-btn" className="flex flex-col items-center justify-center gap-1 py-3 font-bold text-[#1c4f9c] text-xs border-r border-slate-200">
        <Phone size={18} strokeWidth={2.5} /> Call
      </a>
      <a href={CONTACT.smsHref} data-testid="sticky-text-btn" className="flex flex-col items-center justify-center gap-1 py-3 font-bold text-[#1c4f9c] text-xs border-r border-slate-200">
        <MessageSquare size={18} strokeWidth={2.5} /> Text
      </a>
      <a href="#contact" data-testid="sticky-quote-btn" className="flex flex-col items-center justify-center gap-1 py-3 font-bold text-white bg-[#e02329] text-xs">
        <FileText size={18} strokeWidth={2.5} /> Free Estimate
      </a>
    </div>
  );
};
